<template>
  <a
    class="anchor"
    :href="link"
    :target="target"
    :class="[mode]"
    @click="(evt) => $emit('onClick', evt)"
  >
    <AssetV3
      v-if="hasIcon"
      class="icon"
      dir="icons"
      :name="iconName"
    />
    <p class="anchor-text white">{{ content }}</p>
  </a>
</template>

<script>
import AssetV3 from '@/components/common/AssetV3.vue';

export default {
  name: 'installments-anchor_button',
  components: { AssetV3 },
  props: {
    content: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
    },
    hasIcon: {
      type: Boolean,
    },
    iconName: {
      type: String,
    },
    link: {
      type: String,
    },
    target: {
      type: String,
    },
  },
  methods: {
    onClick(value) {
      this.$emit('click', value);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/scss/__new-styles.scss';

  .anchor {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border: 0;
    -webkit-tap-highlight-color: transparent;
    width: 100%;
    background-color: $primary-500;
    border-radius: 4px;
    height: 48px;
    text-decoration: none;

    @media (min-width: $lg) {
      display: flex;
      gap: 4px;
      justify-content: space-between;
      align-items: center;
      padding: 16px 7px;
    }

    p {
      font-weight: 700;
      font-family: var(--font-family);
      line-height: 24px;
    }

    .icon {
      position: absolute;
      top: 16px;
      left: 20px;

      @media (min-width: $lg) {
        position: unset;
        top: unset;
        left: unset;
      }
    }

    &:hover {
      background-color: $primary-700;
    }

    @media (min-width: $lg) {
      height: 38px;
    }

    &.semi-primary {
      background-color: var(--white);
      border:1px solid var(--gray-300);

      p {
        font-family: var(--font-family);
        font-weight: 400;
        font-size: 18px;
        line-height: 24px;
        color: var(--gray-700) !important;

        @media (min-width: $lg) {
          font-size: 16px;
          line-height: 24px;
        }
      }

      &:hover {
        background-color: $primary-300;
      }
    }
    &.secundary {
      background-color: var(--blue-200);
      border:1px solid var(--blue-200);

      p {
        font-family: var(--font-family);
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        color: var(--blue-400) !important;

        @media (min-width: $lg) {
          font-size: 16px;
          line-height: 24px;
        }
      }

      &:hover {
        background-color: $primary-300;
      }
    }
    .anchor-text {
      font-family: var(--font-family);
      font-weight: 600;
      font-size: 18px;
      line-height: 28px;

      @media (min-width: $lg) {
        font-size: 16px;
        line-height: 24px;
        padding: 16px 7px;
      }
    }
  }
</style>
